import { Box, IconButton, Typography } from "@mui/material";
import { MdOutlineArrowBackIosNew } from "react-icons/md";

const BackButton = ({ primaryText, secondaryText, goBack, sx }) => {
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mt: 2, ...sx }}>
        {goBack && (
          <IconButton onClick={goBack} sx={{ color: "text.primary" }}>
            <MdOutlineArrowBackIosNew size={20} />
          </IconButton>
        )}
        <Typography variant="h6" color="text" fontWeight="bold">
          <Box component="span" sx={{ color: "primary.main" }}>
            {primaryText}{" "}
          </Box>
          {secondaryText}
        </Typography>
      </Box>
    </>
  );
};

export default BackButton;
